// CapacitorHttp patches fetch and XHR and breaks Blob bodies; use the
// WebView's original fetch the bridge preserves (see docs/adr/0005).
type WebFetch = typeof fetch

const getWebFetch = (): WebFetch => {
  const original = (globalThis as { CapacitorWebFetch?: WebFetch })
    .CapacitorWebFetch
  return original ?? fetch
}

/**
 * PUT a binary blob to a presigned S3 URL. The URL's signature covers
 * Content-Type, so the header must match what the API signed.
 */
export async function putToPresignedUrl(
  url: string,
  blob: Blob,
  contentType: string,
): Promise<void> {
  const webFetch = getWebFetch()
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 120_000)
  try {
    let response: Response
    try {
      response = await webFetch(url, {
        method: 'PUT',
        body: blob,
        headers: { 'Content-Type': contentType },
        signal: controller.signal,
      })
    } catch (error) {
      const timedOut = error instanceof Error && error.name === 'AbortError'
      if (timedOut) throw new Error('Photo upload failed: timed out')
      // Stable message for the UI/queue; the transport error rides along
      throw new Error('Photo upload failed: network error', { cause: error })
    }
    if (!response.ok) {
      throw new Error(`Photo upload failed with status ${response.status}`)
    }
  } finally {
    clearTimeout(timeout)
  }
}
